import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import { FormattedMessage } from 'react-intl';
import Button from '../../../global/Button/Button';

// mutations
import SharedSaveSearch from '../../../mutations/SharedSaveSearch';

// styles
import styles from './FollowSearchButton.scss';

// helpers
import get from 'lodash.get';
import classnames from 'classnames';
import { FOLLOW_DEALER_FLOW, sharedLoginCheck } from '../../../authentication/sharedLoginCheck';

export class FollowSearchButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = { loading: false };

        this.handleClick = this.handleClick.bind(this);
        this.handleFollowSearchCompleted = this.handleFollowSearchCompleted.bind(this);
        this.handleLoginSuccess = this.handleLoginSuccess.bind(this);
        this.saveSearch = this.saveSearch.bind(this);
    }
    getFavoritedSearchId() {
        return get(this.props, 'favoritesConnection.edges[0].node.serviceId');
    }
    saveSearch({ userId, favoritedSearchId }) {
        SharedSaveSearch.commit(this.props.relay.environment, {
            userId,
            favoritedSearchId,
            page: this.props.page,
            onCompleted: this.handleFollowSearchCompleted,
            onError: this.handleFollowSearchCompleted,
        });
    }
    showAuthModal() {
        sharedLoginCheck({
            onSuccess: this.handleLoginSuccess,
            authOptions: { flow: FOLLOW_DEALER_FLOW },
        });
    }
    handleLoginSuccess({ userId }) {
        this.saveSearch({ userId });
    }
    handleClick() {
        if (this.props.userId) {
            this.setState({ loading: true }, () => {
                this.saveSearch({
                    userId: this.props.userId,
                    favoritedSearchId: this.getFavoritedSearchId(),
                });
            });
        } else {
            this.showAuthModal();
        }
    }
    handleFollowSearchCompleted() {
        if (this.state.loading) {
            this.setState({ loading: false }, () => {
                this.props.onFollowSearchCompleted();
            });
        } else {
            this.props.onFollowSearchCompleted();
        }
    }
    render() {
        const { size, fullWidth } = this.props;
        const className = classnames(styles.button, this.props.className);

        return (
            <Button
                className={className}
                disabled={this.state.loading}
                size={size}
                isSecondary={size !== 'large'}
                fullWidth={fullWidth}
                onClick={this.handleClick}
                dataTn="item-actions-follow-search"
            >
                {this.getFavoritedSearchId() ? (
                    <FormattedMessage
                        id="FollowSearchButton.following"
                        defaultMessage="Following"
                    />
                ) : (
                    <FormattedMessage id="FollowSearchButton.follow" defaultMessage="Follow" />
                )}
            </Button>
        );
    }
}

FollowSearchButton.propTypes = {
    className: PropTypes.string,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    fullWidth: PropTypes.bool,
    userId: PropTypes.string,
    user: PropTypes.object,
    relay: PropTypes.object,
    page: PropTypes.string.isRequired,
    onFollowSearchCompleted: PropTypes.func,
};

FollowSearchButton.defaultProps = {
    size: 'large',
    fullWidth: false,
    favoritesConnection: PropTypes.object,
    onFollowSearchCompleted: () => ({}),
};

export default createFragmentContainer(FollowSearchButton, {
    favoritesConnection: graphql`
        fragment FollowSearchButton_favoritesConnection on favoritesConnection {
            edges {
                node {
                    serviceId
                }
            }
        }
    `,
});
